import React from "react";
import "./styles.css";
import { Layout, theme } from "antd";
import { Route, Routes } from "react-router-dom";
import SessionTimeout from "../component/sessionTimeout";

import Header from "./Header";
import Siders from "./sider";

import DashboardScreen from "../screens/dashboardScreen";
import HomeScreen from "../screens/newsScreen";

import Settings from "../screens/settingsScreen";

import PodcastScreen from "../screens/podcastscreen";
import ReelsScreen from "../screens/reelsscreen";
import GulfVideoScreen from "../screens/gulfVideoScreen";
import UserScreen from "../screens/userscreen";
import CategoryScreen from "../screens/categoryscreen";
import EditorialScreen from "../screens/editorialscreen";
import CreateUser from "../screens/userscreen/components/newform";
import NewForm from "../screens/newsScreen/component/newform";
import PollScreen from "../screens/pollscreeen/index";
import PollsForm from "../screens/pollscreeen/component/newform";
import VidyaScreeen from "../screens/vidyaPrabhaadham/index";
import NjayarScreen from "../screens/njayarPrabhaadham/index";
import CategoryForm from "../screens/categoryscreen/component/categoryForm";
import BannerScreen from "../screens/bannerScreen";
import WebStories from "../screens/webStoriesScreen";
import WebStoriesForm from "../screens/webStoriesScreen/component/form";
import WebStoriesImageList from "../screens/webStoriesScreen/component/dataList";
import InSnap from "../screens/inSnapScreen";
import InSnapForm from "../screens/inSnapScreen/component/form";
import InSnapImageList from "../screens/inSnapScreen/component/imageList";
import ProfileScreen from "../screens/profileScreen";
import EditProfileScreen from "../screens/profileScreen/component/editForm";

import ChangePassword from "../screens/profileScreen/component/changePassword";
import SubCategoryscreen from "../screens/subCategoryscreen";
import TagScreen from "../screens/tagsScreen";
import ArticleScreen from "../screens/articlescreen";
import NjayarForm from "../screens/njayarPrabhaadham/component/createNjayarForm";
import NewFormNjayarArticles from "../screens/njayarPrabhaadham/component/newform";
import NjayarArticles from "../screens/njayarPrabhaadham/component/njayarArticles";
import NewFormEditoriL from "../screens/editorialscreen/component/newform";
import NewFormArticle from "../screens/articlescreen/component/newForm";
import BannerForm from "../screens/bannerScreen/component/newForm";
import NewFormVidyaArticles from "../screens/vidyaPrabhaadham/component/newform";

import AddScreen from "../screens/addScreen";

import EPaperScreeen from "../screens/Epaper";
import EpaperForm from "../screens/Epaper/component/newform";
import CommonPagesUpload from "../screens/Epaper/CommonPagesUpload";

import Quiz from "../screens/quiz/master";
import QuizCampForm from "../screens/quiz/master/campainForm";
import QuizQuestion from "../screens/quiz/questions";
import QuestionForm from "../screens/quiz/questions/questionForm";
import QuizAnswers from "../screens/quiz/answers";

import Form from "../screens/form";
import CreateForm from "../screens/form/form";
import FormAnswers from "../screens/form/answers";
import MatchPredictions from "../screens/matchPredictions";

import Frames from "../screens/framesScreen";
import CreateFrames from "../screens/framesScreen/components/form";

import ElectionScreen from "../screens/electionScreen";
import ElectionForm from "../screens/electionScreen/newForm";
import ElectionItem from "../screens/electionScreen/Items";
import ElectionItemForm from "../screens/electionScreen/Items/newForm";
import ElectionDataScreen from "../screens/electionScreen/data";
import HighLights from "../screens/highlghtsscreen";
import HighlightsNewForm from "../screens/highlghtsscreen/components/newform";
import CampaignScreen from "../screens/campaignScreen";
import CreateCampaign from "../screens/campaignScreen/newForm";
import EpaperUsers from "../screens/epaperUsers";
import EpaperUsersReports from "../screens/epaperUsers/reports";
import EpaperUsersSubscriptions from "../screens/epaperUsers/subscriptions";
import AgentsScreen from "../screens/agentsScreen";
import CreateAgent from "../screens/agentsScreen/components/newform";
import AgentView from "../screens/agentsScreen/view";
import SpecialPage from "../screens/SpecialPage";
import SubscriptionPlanScreen from "../screens/subscriptionPlanScreen";
import CreateSubscriptionPlan from "../screens/subscriptionPlanScreen/components/newform";
import EpaperSettings from "../screens/epaperSettings";
import EpaperCountries from "../screens/epaperSettings/countries";
import EpaperZones from "../screens/epaperSettings/zones";
import EpaperRegions from "../screens/epaperSettings/regions";
import UnifiedContent from "../screens/unifiedContent";
import UnifiedForm from "../screens/unifiedContent/component/unifiedForm";
import NjayarMasterForm from "../screens/unifiedContent/component/njayarMasterForm";
import NjayarArticlesView from "../screens/unifiedContent/component/njayarArticlesView";
import SessionsScreen from "../screens/sessionsScreen";
import ReleaseNotificationsScreen from "../screens/releaseNotifications";
import ModuleGuard from "./ModuleGuard";

function Routing() {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout>
      <Layout>
        <SessionTimeout />
        <div className="desktop-sider">
          <Siders />
        </div>
        <Layout.Content>
          <Header />
          <div className="routeBox">
            <ModuleGuard>
            <Routes>
              <Route path="/" element={<DashboardScreen />} />
              <Route path="/home" element={<HomeScreen />} />
              <Route path="/home/news" element={<NewForm />} />
              <Route path="/home/news/:id" element={<NewForm />} />
              <Route path="/reels" element={<ReelsScreen />} />
              <Route path="/gulf-videos" element={<GulfVideoScreen />} />
              <Route path="/podcast" element={<PodcastScreen />} />

              <Route path="/categories" element={<CategoryScreen />} />
              <Route path="/categories-form" element={<CategoryForm />} />
              <Route path="/editorial" element={<EditorialScreen />} />
              <Route
                path="/editorial/createform"
                element={<NewFormEditoriL />}
              />
              <Route
                path="/editorial/createform/:id"
                element={<NewFormEditoriL />}
              />
              <Route path="/polls" element={<PollScreen />} />
              <Route path="/poll/form/:id" element={<PollsForm />} />
              <Route path="/banner" element={<BannerScreen />} />
              <Route path="/banner/Create" element={<BannerForm />} />
              <Route path="/webstories" element={<WebStories />} />
              <Route path="/createwebStories" element={<WebStoriesForm />} />
              <Route
                path="/createwebStories/:id"
                element={<WebStoriesForm />}
              />
              <Route path="/storiesList" element={<WebStoriesImageList />} />
              <Route path="/VidyaScreeen" element={<VidyaScreeen />} />
              <Route
                path="/VidyaScreeen/NewFormVidyaArticles/:id"
                element={<NewFormVidyaArticles />}
              />
              <Route
                path="/VidyaScreeen/NewFormVidyaArticles"
                element={<NewFormVidyaArticles />}
              />

              <Route path="/NjayarScreen" element={<NjayarScreen />} />
              <Route path="/tags" element={<TagScreen />} />
              <Route path="/inSnap" element={<InSnap />} />
              <Route path="/insnap-form" element={<InSnapForm />} />
              <Route path="/insnap-imageList" element={<InSnapImageList />} />
              <Route path="/profile" element={<ProfileScreen />} />
              <Route path="/editprofile" element={<EditProfileScreen />} />
              <Route path="/ChangePassword/form" element={<ChangePassword />} />
              <Route path="/SubCategory" element={<SubCategoryscreen />} />
              <Route path="/Article" element={<ArticleScreen />} />
              <Route path="/Article/createForm" element={<NewFormArticle />} />
              <Route
                path="/Article/createForm/:id"
                element={<NewFormArticle />}
              />
              <Route path="/NjayarScreen/NjayarForm" element={<NjayarForm />} />
              <Route
                path="/NjayarScreen/njayarArticles/:id"
                element={<NjayarArticles />}
              />
              <Route
                path="/NjayarScreen/NewFormNjayarArticles/:id"
                element={<NewFormNjayarArticles />}
              />

              <Route path="AddScreen" element={<AddScreen />} />

              <Route path="/Epaper" element={<EPaperScreeen />} />
              <Route path="/EpaperForm/:id" element={<EpaperForm />} />
              <Route
                path="/EpaperCommonPages"
                element={<CommonPagesUpload />}
              />

              <Route path="/Quiz" element={<Quiz />} />
              <Route path="/QuizCampForm/:id" element={<QuizCampForm />} />
              <Route path="/QuizQuestion/:id" element={<QuizQuestion />} />
              <Route path="/QuestionForm/:id/:qid" element={<QuestionForm />} />
              <Route path="/QuizAnswers/:id/:qid" element={<QuizAnswers />} />

              <Route path="/form" element={<Form />} />
              <Route path="/form/:id" element={<CreateForm />} />
              <Route path="/match-predictions" element={<MatchPredictions />} />
              <Route path="/form-answers/:id" element={<FormAnswers />} />

              <Route path="/frames" element={<Frames />} />
              <Route path="/frames/:id" element={<CreateFrames />} />

              <Route path="/election" element={<ElectionScreen />} />
              <Route path="/election/:id" element={<ElectionForm />} />
              <Route path="/election-data/:EID" element={<ElectionDataScreen />} />
              <Route path="/election-items/:EID" element={<ElectionItem />} />
              <Route
                path="/election-items/:EID/:id"
                element={<ElectionItemForm />}
              />

              <Route path="/users" element={<UserScreen />} />
              <Route path="/users/form/:id" element={<CreateUser />} />

              <Route path="/highlights" element={<HighLights />} />
              <Route path="/highlights/form" element={<HighlightsNewForm />} />

              <Route path="/campaign" element={<CampaignScreen />} />
              <Route path="/campaign/form/:id" element={<CreateCampaign />} />
              <Route path="/campaign/:id" element={<CampaignScreen />} />

              <Route path="/unified-content" element={<UnifiedContent />} />
              <Route path="/unified-content/create" element={<UnifiedForm />} />
              <Route
                path="/unified-content/edit/:type/:id"
                element={<UnifiedForm />}
              />
              <Route
                path="/unified-content/njayar/create-master"
                element={<NjayarMasterForm />}
              />
              <Route
                path="/unified-content/njayar/master/:masterId"
                element={<NjayarArticlesView />}
              />
              <Route
                path="/unified-content/njayar/master/:masterId/create"
                element={<UnifiedForm />}
              />
              <Route
                path="/unified-content/njayar/master/:masterId/edit/:type/:id"
                element={<UnifiedForm />}
              />

              <Route path="/sessions" element={<SessionsScreen />} />
              <Route
                path="/release-notifications"
                element={<ReleaseNotificationsScreen />}
              />
              <Route path="/settings" element={<Settings />} />
              <Route path="/agents" element={<AgentsScreen />} />
              <Route path="/agents/view/:id" element={<AgentView />} />
              <Route path="/agents/form/:id" element={<CreateAgent />} />
              <Route path="/epaper-users" element={<EpaperUsers />} />
              <Route path="/epaper-users/reports" element={<EpaperUsersReports />} />
              <Route path="/epaper-users/subscriptions" element={<EpaperUsersSubscriptions />} />
              <Route path="/special-page" element={<SpecialPage />} />

              <Route
                path="/subscription-plans"
                element={<SubscriptionPlanScreen />}
              />
              <Route
                path="/subscription-plans/form/:id"
                element={<CreateSubscriptionPlan />}
              />
              <Route path="/epaper-settings" element={<EpaperSettings />} />
              <Route path="/epaper-settings/countries" element={<EpaperCountries />} />
              <Route path="/epaper-settings/zones" element={<EpaperZones />} />
              <Route path="/epaper-settings/regions" element={<EpaperRegions />} />
            </Routes>
            </ModuleGuard>
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
}

export default Routing;
